<template>
  <v-container>
    <h1 class="text-h3">Edit Restaurant Menu</h1>
    <div>
      <RestaurantMenuDialog @submit="refreshMenuTable" :restaurant-id="restaurantId">
        <template #activator="{ on }">
          <v-btn v-on="on" color="accent">New Item</v-btn>
        </template>
      </RestaurantMenuDialog>

      <RestaurantMenuTable @change="refreshMenuTable" :restaurant-id="restaurantId" :key="menuTableKey" />
    </div>
  </v-container>
</template>

<script>
import RestaurantMenuTable from '@/components/RestaurantManagement/RestaurantMenuTable2.vue'
import RestaurantMenuDialog from '@/components/RestaurantManagement/RestaurantMenuDialog.vue'

export default {
  name: 'MenuManagementView',

  props: {
    'restaurant-id': {
      type: String,
      required: true
    }
  },

  components: { RestaurantMenuTable, RestaurantMenuDialog },

  data () {
    return ({
      menuTableKey: Math.random()
    })
  },

  methods: {
    refreshMenuTable () {
      this.$data.menuTableKey = Math.random()
    }
  }
}
</script>
